import { RoutePaths } from "enums/RoutePaths";
import AdminLayout from "pages/AdminLayout/AdminLayout";
import Login from "pages/Login/Login";
import NoAccess from "pages/NoAccess/NoAccess";
import SuperAdminMosqueSelection from "pages/SuperAdminMosqueSelection/SuperAdminMosqueSelection";
import GlobalPushPage from "pages/SuperAdminPages/GlobalPushPage/GlobalPushPage";
import AdminPushPage from "pages/SuperAdminPages/AdminPushPage/AdminPushPage";
import PushLogPage from "pages/SuperAdminPages/PushLogPage/PushLogPage";
import InquiriesOverviewPage from "pages/SuperAdminPages/InquiriesPage/InquiriesOverviewPage";
import ContactInboxPage from "pages/SuperAdminPages/InquiriesPage/ContactInboxPage";
import AdminRequestsPage from "pages/SuperAdminPages/InquiriesPage/AdminRequestsPage";
import MosqueSuggestionsPage from "pages/SuperAdminPages/InquiriesPage/MosqueSuggestionsPage";
import DirectPushPage from "pages/SuperAdminPages/DirectPushPage/DirectPushPage";
import HijriPage from "pages/SuperAdminPages/HijriPage/HijriPage";
import SuperAdminPrayerTimesPage from "pages/SuperAdminPages/SuperAdminPrayerTimesPage/SuperAdminPrayerTimesPage";
import UsersPage from "pages/SuperAdminPages/UsersPage/UsersPage";
import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ScrollToTop from "utils/ScrollToTop";
import { AdminUiProvider } from "stories/Admin";
import AuthProvider, { useAuth } from "./AuthProvider";
import AdminPage from "./pages/AdminPage/AdminPage";
import BlogPage from "./pages/BlogPage/BlogPage";
import CampaignPage from "./pages/CampaignPage/CampaignPage";
import EventPage from "./pages/EventPage/EventPage";
import InformationPage from "./pages/InformationPage/InformationPage";
import JamatPage from "./pages/JamatPage/JamatPage";
import NotificationPage from "./pages/NotificationPage/NotificationPage";
import PostersPage from "./pages/PostersPage/PostersPage";
import PrayerTimesPage from "./pages/PrayerTimes/PrayerTimes";
import SpecialPrayerSettings from "./pages/SpecialPrayerSettings/SpecialPrayerSettings";
import AddMosquePage from "./pages/SuperAdminPages/AddMosquePage/AddMosquePage";
import DuaPage from "pages/SuperAdminPages/DuaPage/DuaPage";
import NamesOfAllahPage from "pages/SuperAdminPages/NamesOfAllah/NamesOfAllahPage";
import ExpressionsPage from "pages/SuperAdminPages/ExpressionsPage/ExpressionsPage";
import HadithPage from "pages/SuperAdminPages/HadithPage/HadithPage";
import AiImamPage from "pages/SuperAdminPages/AiImamPage/AiImamPage";
import AiBonnPrompterPage from "pages/SuperAdminPages/AiBonnPrompterPage/AiBonnPrompterPage";
import QuranPage from "pages/SuperAdminPages/QuranPage/QuranPage";
import CachePage from "pages/SuperAdminPages/CachePage/CachePage";
import ExternalPage from "pages/SuperAdminPages/ExternalPage/ExternalPage";
import JanazahPage from "pages/SuperAdminPages/JanazahPage/JanazahPage";
import JanazahAiLogPage from "pages/SuperAdminPages/JanazahPage/JanazahAiLogPage";
import FuneralAgenciesPage from "pages/SuperAdminPages/JanazahPage/FuneralAgenciesPage";
import RegistreringerPage from "pages/SuperAdminPages/RegistreringerPage/RegistreringerPage";
import AiBonFeedbackPage from "pages/SuperAdminPages/AiBonFeedbackPage/AiBonFeedbackPage";
import MosqueStatsPage from "pages/SuperAdminPages/MosqueStatsPage/MosqueStatsPage";
import OverviewPage from "pages/SuperAdminPages/OverviewPage/OverviewPage";
import AppUsagePage from "pages/SuperAdminPages/AppUsagePage/AppUsagePage";
import ApiKeysPage from "pages/SuperAdminPages/ApiKeysPage/ApiKeysPage";
import PartnersPage from "pages/SuperAdminPages/PartnersPage/PartnersPage";
import KidsPage from "pages/SuperAdminPages/KidsPage/KidsPage";
import PartnerPage from "pages/PartnerPage/PartnerPage";
import ApiPage from "pages/ApiPage/ApiPage";
import AdminsPage from "pages/AdminsPage/AdminsPage";
import TvPage from "pages/TvPage/TvPage";
import TvStudioPage from "pages/TvStudioPage/TvStudioPage";
import TvSchedulePage from "pages/TvSchedulePage/TvSchedulePage";
import TvDevicesPage from "pages/SuperAdminPages/TvDevicesPage/TvDevicesPage";
import TvAiLogPage from "pages/SuperAdminPages/TvAiLogPage/TvAiLogPage";
import PrayerCalendarLogPage from "pages/SuperAdminPages/PrayerCalendarLogPage/PrayerCalendarLogPage";
import PrayerCalendarPage from "pages/PrayerCalendarPage/PrayerCalendarPage";
import CreateMosqueRequestPage from "pages/CreateMosqueRequestPage/CreateMosqueRequestPage";
import LocationsPage from "pages/SuperAdminPages/LocationsPage/LocationsPage";
import MawaqeetPushPage from "pages/MawaqeetAdminPages/MaqaweetPushPage/MawaqeetPushPage";
import MawaqeetPrayerTimes from "pages/MawaqeetAdminPages/MawaqeetPrayerTimes/MawaqeetPrayerTimes";
import MawaqeetLocationsPage from "pages/MawaqeetAdminPages/MawaqeetLocationsPage/MawaqeetLocationsPage";
import MawaqeetGenerateTimes from "pages/MawaqeetAdminPages/MawaqeetGenerateTimes/MawaqeetGenerateTimes";
import MawaqeetRamadanPage from "pages/MawaqeetAdminPages/MawaqeetRamadanPage/MawaqeetRamadanPage";
import MyMosqueLayoutPage from "pages/MyMosqueLayoutPage/MyMosqueLayoutPage";
import PaymentSettingsPage from "pages/PaymentSettingsPage/PaymentSettingsPage";
import DonationResultPage from "pages/DonationResultPage/DonationResultPage";
import DonationSummaryPage from "pages/DonationSummaryPage/DonationSummaryPage";
import { appCheck, getAppCheckToken } from "./firebase";

// Log App Check status on app initialization
console.log("[App] ========== APP CHECK STATUS ==========");
console.log(
  "[App] REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY:",
  process.env.REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY ? "SET ✅" : "NOT SET ❌",
);
console.log("[App] App Check initialized:", appCheck ? "YES ✅" : "NO ❌");
console.log("[App] ========================================");

const ProtectedRoutes: React.FC = () => {
  const { isSuperAdmin, isMawaqeetAdmin, mawaqeetAdminMode, superAdminMode } =
    useAuth();

  return (
    <Routes>
      {/* Super Admin mosque selection route */}
      {isSuperAdmin && (
        <Route
          path={RoutePaths.SuperAdminMosqueSelection}
          element={<SuperAdminMosqueSelection />}
        />
      )}

      {/* Super Admin side menu routes */}
      {superAdminMode && isSuperAdmin ? (
        <Route element={<AdminLayout />}>
          <Route path={RoutePaths.MosqueAdmin} element={<AddMosquePage />} />
          <Route path={RoutePaths.Dua} element={<DuaPage />} />
          <Route path={RoutePaths.GlobalPush} element={<GlobalPushPage />} />
          <Route path={RoutePaths.AdminPush} element={<AdminPushPage />} />
          <Route path={RoutePaths.PushLog} element={<PushLogPage />} />
          <Route path={RoutePaths.DirectPush} element={<DirectPushPage />} />
          <Route path={RoutePaths.HijriDates} element={<HijriPage />} />
          <Route path={RoutePaths.Users} element={<UsersPage />} />
          <Route path={RoutePaths.Locations} element={<LocationsPage />} />
          <Route
            path={RoutePaths.SuperAdminPrayerTimes}
            element={<SuperAdminPrayerTimesPage />}
          />
          <Route
            path={RoutePaths.SuperAdminGenerateTimes}
            element={<MawaqeetGenerateTimes superAdmin />}
          />
          <Route
            path={RoutePaths.NamesOfAllah}
            element={<NamesOfAllahPage />}
          />
          <Route path={RoutePaths.Expressions} element={<ExpressionsPage />} />
          <Route path={RoutePaths.Hadith} element={<HadithPage />} />
          <Route path={RoutePaths.AiImam} element={<AiImamPage />} />
          <Route
            path={RoutePaths.AiBonnPrompter}
            element={<AiBonnPrompterPage />}
          />
          <Route path={RoutePaths.Quran} element={<QuranPage />} />
          <Route path={RoutePaths.Cache} element={<CachePage />} />
          <Route path={RoutePaths.External} element={<ExternalPage />} />
          <Route path={RoutePaths.Janazah} element={<JanazahPage />} />
          <Route
            path={RoutePaths.JanazahAiLog}
            element={<JanazahAiLogPage />}
          />
          <Route
            path={RoutePaths.FuneralAgencies}
            element={<FuneralAgenciesPage />}
          />
          <Route
            path={RoutePaths.Registreringer}
            element={<RegistreringerPage />}
          />
          <Route
            path={RoutePaths.AiBonFeedback}
            element={<AiBonFeedbackPage />}
          />
          <Route path={RoutePaths.MosqueStats} element={<MosqueStatsPage />} />
          <Route path={RoutePaths.Overview} element={<OverviewPage />} />
          <Route path={RoutePaths.AppUsage} element={<AppUsagePage />} />
          <Route
            path={RoutePaths.AdminDonations}
            element={<DonationSummaryPage scope="all" />}
          />
          <Route
            path={RoutePaths.Inquiries}
            element={<InquiriesOverviewPage />}
          />
          <Route
            path={RoutePaths.ContactInbox}
            element={<ContactInboxPage />}
          />
          <Route
            path={RoutePaths.AdminRequests}
            element={<AdminRequestsPage />}
          />
          <Route
            path={RoutePaths.MosqueSuggestions}
            element={<MosqueSuggestionsPage />}
          />
          <Route path={RoutePaths.ApiKeys} element={<ApiKeysPage />} />
          <Route path={RoutePaths.Partners} element={<PartnersPage />} />
          <Route path={RoutePaths.Kids} element={<KidsPage />} />
          <Route path={RoutePaths.TvDevices} element={<TvDevicesPage />} />
          <Route path={RoutePaths.TvAiLog} element={<TvAiLogPage />} />
          <Route
            path={RoutePaths.PrayerCalendarLog}
            element={<PrayerCalendarLogPage />}
          />
          <Route
            path={RoutePaths.MawaqeetPush}
            element={<MawaqeetPushPage />}
          />
          <Route
            path={RoutePaths.MawaqeetPrayerTimes}
            element={<MawaqeetPrayerTimes />}
          />
          <Route
            path={RoutePaths.MawaqeetLocations}
            element={<MawaqeetLocationsPage />}
          />
          <Route
            path={RoutePaths.MawaqeetGenerateTimes}
            element={<MawaqeetGenerateTimes />}
          />
          <Route
            path={RoutePaths.MawaqeetRamadan}
            element={<MawaqeetRamadanPage />}
          />
        </Route>
      ) : isMawaqeetAdmin ? (
        <Route element={<AdminLayout />}>
          <Route
            path={RoutePaths.MawaqeetPush}
            element={<MawaqeetPushPage />}
          />
          <Route
            path={RoutePaths.MawaqeetPrayerTimes}
            element={<MawaqeetPrayerTimes />}
          />
          <Route
            path={RoutePaths.MawaqeetLocations}
            element={<MawaqeetLocationsPage />}
          />
          <Route
            path={RoutePaths.MawaqeetGenerateTimes}
            element={<MawaqeetGenerateTimes />}
          />
          <Route
            path={RoutePaths.MawaqeetRamadan}
            element={<MawaqeetRamadanPage />}
          />
          <Route
            path="*"
            element={<Navigate to={RoutePaths.MawaqeetPrayerTimes} replace />}
          />
        </Route>
      ) : (
        // Logged-in routes with regular layout
        <Route element={<AdminLayout />}>
          <Route path={RoutePaths.Root} element={<AdminPage />} />
          <Route path={RoutePaths.Jamat} element={<JamatPage />} />
          <Route path={RoutePaths.PrayerTimes} element={<PrayerTimesPage />} />
          <Route
            path={RoutePaths.PdfGenerator}
            element={<PrayerCalendarPage />}
          />
          <Route
            path={RoutePaths.PrayerCalendar}
            element={<Navigate to={RoutePaths.PdfGenerator} replace />}
          />
          <Route
            path={RoutePaths.RamadanCalendar}
            element={
              <Navigate
                to={`${RoutePaths.PdfGenerator}?type=ramadan`}
                replace
              />
            }
          />
          <Route
            path={RoutePaths.SpecialPrayerSettings}
            element={<SpecialPrayerSettings />}
          />
          <Route
            path={RoutePaths.Notification}
            element={<NotificationPage />}
          />
          <Route path={RoutePaths.Event} element={<EventPage />} />
          <Route path={RoutePaths.Blog} element={<BlogPage />} />
          <Route path={RoutePaths.Posters} element={<PostersPage />} />
          <Route
            path={RoutePaths.PostersAll}
            element={<PostersPage mode="all" />}
          />
          <Route path={RoutePaths.Information} element={<InformationPage />} />
          <Route path={RoutePaths.Campaign} element={<CampaignPage />} />
          <Route
            path={RoutePaths.Donations}
            element={<DonationSummaryPage scope="mosque" />}
          />
          <Route
            path={RoutePaths.PaymentSettings}
            element={<PaymentSettingsPage />}
          />
          <Route
            path={RoutePaths.MyMosqueLayout}
            element={<MyMosqueLayoutPage />}
          />
          <Route path={RoutePaths.Api} element={<ApiPage />} />
          <Route path={RoutePaths.Admins} element={<AdminsPage />} />
          <Route path={RoutePaths.Tv} element={<TvPage />} />
          <Route path={RoutePaths.TvStudio} element={<TvStudioPage />} />
          <Route path={RoutePaths.TvSchedule} element={<TvSchedulePage />} />
        </Route>
      )}

      {/* Fallback Route for Undefined Paths */}
      <Route
        path={RoutePaths.NotFound}
        element={
          isSuperAdmin ? (
            <Navigate to={RoutePaths.SuperAdminMosqueSelection} replace />
          ) : isMawaqeetAdmin ? (
            <Navigate to={RoutePaths.MawaqeetPrayerTimes} replace />
          ) : (
            <Navigate to={RoutePaths.Root} replace />
          )
        }
      />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <AdminUiProvider>
        <ScrollToTop />
        <Routes>
          {/* Public route */}
          <Route path={RoutePaths.Login} element={<Login />} />
          <Route path={RoutePaths.NoAccess} element={<NoAccess />} />
          <Route path={RoutePaths.Partner} element={<PartnerPage />} />
          <Route
            path={RoutePaths.MosqueRequestForm}
            element={<CreateMosqueRequestPage />}
          />
          <Route
            path={RoutePaths.DonationThanks}
            element={<DonationResultPage result="thanks" />}
          />
          <Route
            path={RoutePaths.DonationCancelled}
            element={<DonationResultPage result="cancelled" />}
          />

          {/* Protected routes that require authentication context */}
          <Route path={RoutePaths.NotFound} element={<ProtectedRoutes />} />
        </Routes>
      </AdminUiProvider>
    </AuthProvider>
  );
};

export default App;
